module.exports = __webpack_public_path__ + "pdf-grey.png?0ddbde6521a1e8ee3236ee18ba2ebcc8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pdf-grey.png
// module id = 1052
// module chunks = 0